import type { Icon } from "@phosphor-icons/react"
import {
  AlarmIcon,
  GearSixIcon,
  HouseIcon,
  KanbanIcon,
  NoteIcon,
} from "@phosphor-icons/react"
import { cn } from "@repo/ui/lib/utils"
import { NavLink } from "react-router"

type Tab = {
  to: string
  label: string
  icon: Icon
}

const tabs: Tab[] = [
  { to: "/", label: "Home", icon: HouseIcon },
  { to: "/reminders", label: "Reminders", icon: AlarmIcon },
  { to: "/notes", label: "Notes", icon: NoteIcon },
  { to: "/projects", label: "Projects", icon: KanbanIcon },
  { to: "/settings", label: "Settings", icon: GearSixIcon },
]

export function BottomTabBar() {
  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-40 border-t bg-background/80 pb-[env(safe-area-inset-bottom)] backdrop-blur-lg supports-[backdrop-filter]:bg-background/60"
    >
      <ul className="mx-auto flex h-16 max-w-md items-stretch px-2">
        {tabs.map(({ to, label, icon: TabIcon }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={to === "/"}
              aria-label={label}
              className={({ isActive }) =>
                cn(
                  "relative flex h-full items-center justify-center rounded-lg text-muted-foreground transition-colors outline-none hover:text-primary focus-visible:ring-2 focus-visible:ring-ring/50",
                  isActive && "text-primary"
                )
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    aria-hidden
                    className={cn(
                      "absolute top-0 h-0.5 w-8 rounded-full bg-primary transition-opacity",
                      isActive ? "opacity-100" : "opacity-0"
                    )}
                  />
                  <TabIcon
                    size={28}
                    weight={isActive ? "fill" : "regular"}
                    aria-hidden
                  />
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
